import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { useRecoilState } from "recoil"
import { ShowHeader } from "../../states/showHeader"
import { Box, Container, Grid } from "src/UILibrary"
import { Title } from "src/components/layout/Title"
import { BookLibraryItem } from "./components/BookLibraryItem"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { ShowToast } from "src/states/showToast"
import { Book, BookLibraryService } from "src/openapi"
import { RESPONSE_CODE, SNACKBAR_TYPES } from "src/modules/const"
import "src/styles/common.scss"

const PAGE_SIZE = 9

export const BookLibraryPage = () => {
  const { t } = useTranslation("translation", { keyPrefix: "book_library" })

  const [, setShowHeader] = useRecoilState(ShowHeader)
  const [, setShowToast] = useRecoilState(ShowToast)

  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })
  const [pageLoad, setPageLoad] = useState<boolean>(false)
  const [end, setEnd] = useState<boolean>(false)
  const [books, setBooks] = useState<Book[]>([])

  const handleGetBooks = () => {
    BookLibraryService.bookList(undefined, books.length, PAGE_SIZE)
      .then((res) => {
        if (res.status === RESPONSE_CODE.SUCCESS) {
          if (
            (res.data?.books as Book[]).length == 0 ||
            (res.data?.books as Book[]).length < PAGE_SIZE ||
            books.length + (res.data?.books as Book[]).length >= res.data?.count!
          ) {
            setEnd(true)
          }
          setBooks([...books, ...(res.data?.books as Book[])])
        } else {
          setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
        }
      })
      .catch(() => {
        setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  useEffect(() => {
    setShowHeader(true)
    if (pageLoad) {
      return
    }
    setPageLoad(true)
    handleGetBooks()
  })

  return (
    <>
      <Title title={t("book_library_title")} sub_title="" />
      <Container
        maxWidth="lg"
        sx={{ px: isTablet ? "0px" : "10px", py: "10px", mb: "0px" }}
        className="main-body-with-footer"
      >
        <Grid container>
          {books.map((book, index) => {
            return <BookLibraryItem key={index} item={book} />
          })}
        </Grid>
        <Box className="box_show_more">
          {end ? <></> : <OutlinedButton caption={t("show_more")} onClick={handleGetBooks} />}
        </Box>
      </Container>
    </>
  )
}
